<div class="srt-stats-content">

  <ngx-popover [placement]="'right'" (show)="show()" (hide)="hide()">
    <button ngx-popover-anchor>
      SRT Stats
    </button>

    <ng-template ngx-popover-template>
      <!-- Popover -->
      <div class="srt-stats-info">
        <!-- Status -->
        <!-- <div class="row">
          <div class="title">Status:</div>
          <div class="value">{{ srtStatsUI?.status }}</div>
        </div> -->
        <!-- healthSummary -->
        <!-- <div class="row">
          <div class="title">Summary:</div>
          <div class="value">{{ srtStatsUI?.healthSummary }}</div>
        </div> -->
        <!-- latency -->
        <div class="row">
          <div class="title">Latency:</div>
          <div class="value">{{ srtStatsUI?.latency }}</div>
        </div>
        <!-- receiveRate -->
        <div class="row">
          <div class="title">Receive Rate:</div>
          <div class="value">{{ srtStatsUI?.receiveRate }}</div>
        </div>
        <!-- bandwidth -->
        <div class="row">
          <div class="title">Bandwidth:</div>
          <div class="value">{{ srtStatsUI?.bandwidth }}</div>
        </div>
        <!-- bufferAvailable -->
        <div class="row">
          <div class="title">Buffer Available:</div>
          <div class="value">{{ srtStatsUI?.bufferAvailable }}</div>
        </div>
        <!-- packetLoss -->
        <div class="row">
          <div class="title">Packets Loss:</div>
          <div class="value">{{ srtStatsUI?.packetLoss }}</div>
        </div>
        <!-- droppedPackets -->
        <div class="row">
          <div class="title">Dropped Packets:</div>
          <div class="value">{{ srtStatsUI?.droppedPackets }}</div>
        </div>
        <!-- retransmissions -->
        <div class="row">
          <div class="title">Retransmissions:</div>
          <div class="value">{{ srtStatsUI?.retransmissions }}</div>
        </div>
        <!-- packetsReceived -->
        <div class="row">
          <div class="title">Packets Received:</div>
          <div class="value">{{ srtStatsUI?.packetsReceived }}</div>
        </div>
      </div>
    </ng-template>

  </ngx-popover>

</div>